import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { FullScreenSpinner } from '@/components/core/common/feedback/FullScreenSpinner';

interface PublicRouteProps {
  children: ReactNode;
  /** Overrides the default spinner for a route with a better-matched skeleton. */
  fallback?: ReactNode;
  redirectTo?: string;
  redirectWhenAuthenticated?: boolean;
}

export function PublicRoute({
  children,
  fallback,
  redirectTo = '/',
  redirectWhenAuthenticated = true,
}: PublicRouteProps) {
  const { user, loading } = useAuth();

  // While the auth check is in flight. Shares `FullScreenSpinner` with
  // `ProtectedRoute` - see the note there for what this replaced.
  if (loading) return <>{fallback ?? <FullScreenSpinner />}</>;

  // Redirect authenticated users away from public routes (like login/register)
  if (redirectWhenAuthenticated && user) {
    return <Navigate to={redirectTo} replace />;
  }

  // User is not authenticated or redirection is disabled, render public content
  return <>{children}</>;
}
